<template>
  <div class="container">
    <el-form size="mini" ref="form" :model="searchInfo" inline class="form">
      <el-row>
        <el-col :span="8">
          <el-form-item label="购买内容:" prop="course_id">
            <el-select
              v-model="searchInfo.course_id"
              filterable
              clearable
              placeholder="请选择"
              :filter-method="handleSearchBuyCourse"
              @change="handleSearch"
              @clear="handleSearch"
            >
              <el-option
                v-for="item in buyCourese"
                :key="item.course_id"
                :label="item.title"
                :value="item.course_id"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="业务类型:" prop="order_type">
            <el-select
              v-model="searchInfo.order_type"
              placeholder="请选择"
              multiple
              @change="handleSearch('orderType')"
              clearable
            >
              <el-option
                v-for="item in orderTypeList"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="废除状态:" prop="repeal_status">
            <el-radio-group
              v-model="searchInfo.repeal_status"
              @change="handleSearch('repealStatus')"
            >
              <el-radio-button :label="-1">全部</el-radio-button>
              <el-radio-button :label="2">未废除</el-radio-button>
              <el-radio-button :label="3">已废除</el-radio-button>
            </el-radio-group>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="8">
          <el-form-item label="审批状态:" prop="approval_status">
            <el-radio-group
              v-model="searchInfo.approval_status"
              @change="handleSearch"
            >
              <el-radio-button :label="-1">全部</el-radio-button>
              <el-radio-button :label="0">无审批</el-radio-button>
              <el-radio-button :label="1">审批中</el-radio-button>
              <el-radio-button :label="3">已拒绝</el-radio-button>
              <el-radio-button :label="2">已同意</el-radio-button>
              <el-radio-button :label="4">已取消</el-radio-button>
            </el-radio-group>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="退款状态:" prop="refund_status">
            <el-radio-group
              v-model="searchInfo.refund_status"
              @change="handleSearch('refundStatus')"
            >
              <el-radio-button :label="-1">全部</el-radio-button>
              <el-radio-button :label="1">退款中</el-radio-button>
              <el-radio-button :label="2">退款失败</el-radio-button>
              <el-radio-button :label="3">退款成功</el-radio-button>
              <el-radio-button :label="4">已取消</el-radio-button>
            </el-radio-group>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="订单状态:" prop="order_status">
            <el-radio-group
              v-model="searchInfo.order_status"
              @change="handleSearch('orderStatus')"
            >
              <el-radio-button :label="-1">全部</el-radio-button>
              <el-radio-button :label="1">待付款</el-radio-button>
              <el-radio-button :label="5">部分付款</el-radio-button>
              <el-radio-button :label="3">已付款</el-radio-button>
              <el-radio-button :label="4">已取消</el-radio-button>
            </el-radio-group>
          </el-form-item>
        </el-col>
        <!-- order_type 被用掉了 -->
        <!-- <el-col :span="8">
          <el-form-item label="订单类型:" prop="item_type">
            <el-radio-group
              v-model="searchInfo.item_type"
              @change="handleSearch"
            >
              <el-radio-button :label="-1">全部</el-radio-button>
              <el-radio-button :label="1">课程订单</el-radio-button>
              <el-radio-button :label="4">活动订单</el-radio-button>
            </el-radio-group>
          </el-form-item>
        </el-col> -->
      </el-row>
    </el-form>
    <div class="orderAmountBox">
      <div class="orderAmount">
        <div class="gray">
          收入总计:{{
            (Math.round(Number(tatistics.income) * 100) -
              Math.round(Number(tatistics.expend) * 100)) /
            100
          }}元
        </div>
      </div>
    </div>
    <el-table
      size="mini"
      v-horizontal-scroll
      ref="multipleTable"
      tooltip-effect="dark"
      style="width: 100%"
      :data="tableData"
      border
      stripe
    >
      <el-table-column label="订单号" prop="order_no" width="160">
        <template slot-scope="scope">
          <span
            class="ordernum editBtn"
            @click="toDetail(scope.row.order_id)"
            >{{ scope.row.order_no }}</span
          >
        </template>
      </el-table-column>
      <el-table-column label="审批状态" prop="approval_status" width="70">
        <template slot-scope="scope">
          <span>{{ handleApprovalStatus(scope.row) }}</span>
        </template>
      </el-table-column>
      <!-- <el-table-column label="订单类型" prop="item_type" width="70">
        <template slot-scope="scope">
          <span v-if="scope.row.item_type === 1">课程订单</span>
          <span v-if="scope.row.item_type === 4">活动订单</span>
        </template>
      </el-table-column> -->
      <el-table-column label="业务类型" prop="status_text" width="90">
        <template slot-scope="scope">
          <span v-if="scope.row.order_type === 1">购课</span>
          <span v-if="scope.row.order_type === 2">退课</span>
          <span v-if="scope.row.order_type === 3">
            转课
            <span>{{
              scope.row.payment_type === 1 ? "[转入]" : "[转出]"
            }}</span>
          </span>
          <span v-if="scope.row.order_type === 4">购活动</span>
          <span v-if="scope.row.order_type === 5">退单</span>
        </template>
      </el-table-column>
      <el-table-column
        label="实收/实退"
        prop="completed_amount"
        width="126"
        min-width="110"
      >
        <template slot-scope="scope">
          <!-- 开通支付，并且是待支付状态，显示 - -->
          <div
            v-if="
              online_pay &&
              scope.row.payment_type == 1 &&
              scope.row.status === 1
            "
          >
            -
          </div>
          <div v-else>
            <div v-if="scope.row.payment_type == 1">
              <span class="moneyType">收</span>
              <span class="editBtn">￥{{ scope.row.completed_amount }}</span>
            </div>
            <div v-if="scope.row.payment_type == 2">
              <span class="moneyType retreat">退</span>
              <span class="orderClose">￥{{ scope.row.completed_amount }}</span>
            </div>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="购买内容" prop="product_name"> </el-table-column>
      <el-table-column label="内容价格" prop="spec_name">
        <template slot-scope="scope">
          {{
            scope.row.order_type === 4
              ? scope.row.receivable_amount
              : scope.row.spec_name
          }}
        </template>
      </el-table-column>
      <el-table-column label="购买/退课数量" prop="scope">
        <template slot-scope="scope">
          <span v-if="scope.row.order_type === 4">1</span>
          <span v-else>{{ scope.row.quantity }}课时</span>
        </template>
      </el-table-column>
      <el-table-column label="赠送数量" prop="give_product_quantity">
        <template slot-scope="scope">
          <span v-if="scope.row.order_type === 4">-</span>
          <span v-else>{{ scope.row.give_product_quantity }}课时</span>
        </template>
      </el-table-column>
      <el-table-column
        label="应收/应退"
        prop="amount"
        width="126"
        min-width="110"
      >
        <template slot-scope="scope">
          <div v-if="scope.row.order_type === 4">-</div>
          <div v-else>
            <div v-if="scope.row.payment_type == 1">
              <span class="moneyType">收</span>
              <span class="editBtn">￥{{ scope.row.receivable_amount }}</span>
            </div>
            <div v-if="scope.row.payment_type == 2">
              <span class="moneyType retreat">退</span>
              <span class="orderClose"
                >￥{{ scope.row.receivable_amount }}</span
              >
            </div>
          </div>
        </template>
      </el-table-column>

      <el-table-column label="创建时间">
        <template slot-scope="scope">
          <div>
            {{ scope.row.create_time }}
          </div>
        </template>
      </el-table-column>
      <el-table-column label="支付时间">
        <template slot-scope="scope">
          <span>
            {{
              scope.row.order_payment_type === 1 ? scope.row.handle_time : "-"
            }}
          </span>
        </template>
      </el-table-column>
      <el-table-column label="订单状态" prop="status" width="80">
        <template slot-scope="scope">
          <span v-if="scope.row.status === 3">-</span>
          <span v-else>{{
            scope.row.order_payment_type === 1
              ? handleOrderStatus(scope.row)
              : "-"
          }}</span>
        </template>
      </el-table-column>
      <el-table-column label="退款状态" prop="status" width="70">
        <template slot-scope="scope">
          <span v-if="scope.row.refund_failed">退款失败</span>
          <span v-else-if="scope.row.status === 3">-</span>
          <span v-else>{{
            scope.row.order_payment_type === 2
              ? handleOrderStatus(scope.row)
              : "-"
          }}</span>
        </template>
      </el-table-column>
      <el-table-column label="退款时间">
        <template slot-scope="scope">
          <span>
            {{
              scope.row.order_payment_type === 2
                ? scope.row.status === 2
                  ? scope.row.handle_time
                  : "-"
                : "-"
            }}
          </span>
        </template>
      </el-table-column>
      <el-table-column label="废除状态" prop="repeal_status" width="70">
        <template slot-scope="scope">
          <span>{{ scope.row.status === 3 ? "已废除" : "-" }}</span>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      :current-page="page"
      :page-size="pageSize"
      :page-sizes="pageSizeArray"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total"
      @current-change="handlePagerChange"
      @size-change="handlePagerSizeChange"
      :style="{ float: 'right', padding: '17px' }"
    >
    </el-pagination>
  </div>
</template>
<script>
import { getSelectCourseList } from "@/api/globalSearch";
import { orderitemListApi, orderTatisticsApi, getPayment } from "@/api/order";
import { dateFormat } from "@/utils/timeFormat";

export default {
  data() {
    return {
      searchInfo: {
        course_id: "",
        order_type: "", // 业务类型
        payment_type: -1, // 主订单收支类型
        order_status: -1, // 订单状态
        refund_status: -1, // 退款状态
        repeal_status: -1, // 废除状态
        approval_status: -1, // 审批状态
        // status: -1, // 废除状态
        item_type: -1, // 订单类型
      },
      orderTypeList: [
        { value: 1, label: "购课" },
        { value: 2, label: "退课" },
        { value: 3, label: "转课" },
        { value: 4, label: "购活动" },
        { value: 5, label: "退单" },
      ],
      tatistics: "", // 总收入
      buyCourese: [], // 购买内容列表
      id: 0,
      tableData: [],
      page: 1,
      pageSize: 10,
      pageSizeArray: [5, 10, 20],
      total: 0,
      online_pay: false, // 是否开通支付
      // 业务类型分为两大类，转课类型同时拥有订单状态和退款状态
      cache: {
        type1: [1, 4, 3],
        type2: [2, 5, 3],
        curType: 0, // 当前数据哪一大类
        lastData: "", // 获取的最新数据
      },
    };
  },

  created() {
    this.id = Number(this.$route.query.id);
    this.handleSearchBuyCourse("");
    this.getorderlist({
      page: this.page,
      page_size: this.pageSize,
      student_id: this.id,
    });
    getPayment().then((res) => {
      if (res.error_code === 0) {
        this.online_pay = res.data.online_pay;
      }
    });
  },
  // 监听变化
  watch: {
    "cache.curType": {
      handler(n, o) {
        // 如果新旧不一致，并且不是初始时，则重置 order_type为获取的最新数据
        if (n !== o && o !== 0) {
          this.searchInfo.order_type = [this.cache.lastData];
        }
        if (n === 1) {
          this.searchInfo.payment_type = 1;
        } else if (n === 2) {
          this.searchInfo.payment_type = 2;
        }
      },
      immediate: false,
      deep: false,
    },
  },
  methods: {
    handleSearchBuyCourse(v) {
      let page_size = 10;
      if (v == "") {
        page_size = 100;
      }
      getSelectCourseList({
        page: 1,
        page_size: page_size,
        title: v,
      }).then((res) => {
        if (res.error_code === 0) {
          this.buyCourese = res.data.list;
        }
      });
    },
    handleSearch(v) {
      let _t = this;
      // 过滤业务类型，只有购课和购活动能共存，其他只能独存
      if (v === "orderType") {
        // let arr = this.searchInfo.order_type;
        // if (arr.length === 0) {
        //   this.searchInfo.payment_type = -1;
        //   this.searchInfo.handle_time = "";
        //   this.searchInfo.refund_time = "";
        //   this.searchInfo.order_status = -1;
        //   this.searchInfo.refund_status = -1;
        // }
        // if (arr.length === 1) {
        //   if (arr.includes(1)) {
        //     this.searchInfo.order_type = [1];
        //     this.searchInfo.payment_type = 1;
        //     this.searchInfo.refund_time = "";
        //     this.searchInfo.refund_status = -1;
        //   }
        //   if (arr.includes(2)) {
        //     this.searchInfo.order_type = [2];
        //     this.searchInfo.payment_type = 2;
        //     this.searchInfo.handle_time = "";
        //     this.searchInfo.order_status = -1;
        //   }
        //   if (arr.includes(3)) {
        //     this.searchInfo.order_type = [3];
        //     this.searchInfo.payment_type = -1;
        //   }
        //   if (arr.includes(4)) {
        //     this.searchInfo.order_type = [4];
        //     this.searchInfo.payment_type = 1;
        //     this.searchInfo.refund_time = "";
        //     this.searchInfo.refund_status = -1;
        //   }
        //   if (arr.includes(5)) {
        //     this.searchInfo.order_type = [5];
        //     this.searchInfo.payment_type = 2;
        //     this.searchInfo.handle_time = "";
        //     this.searchInfo.order_status = -1;
        //   }
        // }
        // // 如果多选是两位时，优先考虑 1&4和2&5，其次直接判断第二位，重置 order_type
        // if (arr.length === 2) {
        //   if (arr.includes(1) && arr.includes(4)) {
        //     this.searchInfo.order_type = [1, 4];
        //     this.searchInfo.payment_type = 1;
        //     this.searchInfo.refund_time = "";
        //     this.searchInfo.refund_status = -1;
        //   } else if (arr.includes(2) && arr.includes(5)) {
        //     this.searchInfo.order_type = [2, 5];
        //     this.searchInfo.payment_type = 2;
        //     this.searchInfo.handle_time = "";
        //     this.searchInfo.order_status = -1;
        //   } else if (arr[1] === 1) {
        //     this.searchInfo.order_type = [1];
        //     this.searchInfo.payment_type = 1;
        //     this.searchInfo.refund_time = "";
        //     this.searchInfo.refund_status = -1;
        //   } else if (arr[1] === 2) {
        //     this.searchInfo.order_type = [2];
        //     this.searchInfo.payment_type = 2;
        //     this.searchInfo.handle_time = "";
        //     this.searchInfo.order_status = -1;
        //   } else if (arr[1] === 3) {
        //     this.searchInfo.order_type = [3];
        //     this.searchInfo.payment_type = -1;
        //     this.searchInfo.handle_time = "";
        //     this.searchInfo.order_status = -1;
        //     this.searchInfo.refund_time = "";
        //     this.searchInfo.refund_status = -1;
        //   } else if (arr[1] === 4) {
        //     this.searchInfo.order_type = [4];
        //     this.searchInfo.payment_type = 1;
        //     this.searchInfo.refund_time = "";
        //     this.searchInfo.refund_status = -1;
        //   } else if (arr[1] === 5) {
        //     this.searchInfo.order_type = [5];
        //     this.searchInfo.payment_type = 2;
        //     this.searchInfo.handle_time = "";
        //     this.searchInfo.order_status = -1;
        //   }
        // }
        // // 如果多选为三位，order_type设置为第三位
        // if (arr.length === 3) {
        //   this.searchInfo.order_type = [arr[2]];
        //   if (arr[2] === 1 || arr[2] === 4) {
        //     this.searchInfo.payment_type = 1;
        //     this.searchInfo.refund_time = "";
        //     this.searchInfo.refund_status = -1;
        //   }
        //   if (arr[2] === 2 || arr[2] === 5) {
        //     this.searchInfo.payment_type = 2;
        //     this.searchInfo.handle_time = "";
        //     this.searchInfo.order_status = -1;
        //   }
        //   if (arr[2] === 3) {
        //     this.searchInfo.payment_type = -1;
        //     this.searchInfo.refund_time = "";
        //     this.searchInfo.refund_status = -1;
        //     this.searchInfo.handle_time = "";
        //     this.searchInfo.order_status = -1;
        //   }
        // }

        // 业务类型分为两大类，转课类型同时拥有订单状态和退款状态
        // 获取最新类型
        this.cache.lastData =
          this.searchInfo.order_type[this.searchInfo.order_type.length - 1];
        // 转课 3 类型除外，转课类型同时拥有订单状态和退款状态
        if (this.cache.lastData !== 3) {
          if (this.cache.type1.includes(this.cache.lastData)) {
            this.cache.curType = 1;
          } else if (this.cache.type2.includes(this.cache.lastData)) {
            this.cache.curType = 2;
          }
        }
        // 业务类型清空时，重置条件
        if (this.searchInfo.order_type.length === 0) {
          this.searchInfo.payment_type = -1;
          this.searchInfo.order_status = -1;
          this.searchInfo.refund_status = -1;
        }
      }
      // 购课订单状态
      if (v === "orderStatus") {
        if (this.searchInfo.order_status > 0) {
          this.searchInfo.payment_type = 1; // 收支类型
          this.searchInfo.refund_time = null; // 清空退款时间
          this.searchInfo.repeal_status = -1; // 清空废除状态
          this.searchInfo.refund_status = -1;
          // // 订单状态，只有已付款的订单才同时包含购课、购活动
          // if (this.searchInfo.order_status === 3) {
          //   this.searchInfo.order_type = [1, 4];
          // } else {
          //   this.searchInfo.order_type = [1];
          // }
          if (this.searchInfo.order_type.length === 0) {
            // 异步处理，防止出现一闪而过的数据
            this.searchInfo.order_type = [];
            setTimeout(() => {
              this.searchInfo.order_type = this.cache.type1;
            }, 0);
          } else {
            // 当只有转课类型时，
            if (this.searchInfo.order_type.includes(3)) {
              // order_type 长度为 1 或包含 1、4时不做处理
              if (
                this.searchInfo.order_type.length === 1 ||
                this.searchInfo.order_type.includes(1) ||
                this.searchInfo.order_type.includes(4)
              ) {
                console.log();
              } else {
                // 其他情况重置
                this.searchInfo.order_type = [];
                setTimeout(() => {
                  this.searchInfo.order_type = this.cache.type1;
                }, 0);
              }
            } else {
              if (
                this.searchInfo.order_type.includes(1) ||
                this.searchInfo.order_type.includes(4)
              ) {
                console.log();
              } else {
                // 其他情况重置
                this.searchInfo.order_type = [];
                setTimeout(() => {
                  this.searchInfo.order_type = this.cache.type1;
                }, 0);
              }
            }
          }
        } else {
          this.searchInfo.handle_time = null; // 清空支付时间
          this.searchInfo.refund_time = null; // 清空退款时间
          this.searchInfo.order_type = []; // 业务类型
          this.searchInfo.payment_type = -1; // 收支类型
        }
      }
      // 退款订单状态
      if (v === "refundStatus") {
        if (this.searchInfo.refund_status > 0) {
          this.searchInfo.payment_type = 2; // 收支类型
          this.searchInfo.handle_time = null; // 清空支付时间
          this.searchInfo.repeal_status = -1; // 清空废除状态
          this.searchInfo.order_status = -1;
          // if (
          //   !this.searchInfo.order_type.includes(2) &&
          //   !this.searchInfo.order_type.includes(5)
          // ) {
          //   this.searchInfo.order_type = [2, 5];
          // }
          if (this.searchInfo.order_type.length === 0) {
            // 异步处理，防止出现一闪而过的数据
            this.searchInfo.order_type = [];
            setTimeout(() => {
              this.searchInfo.order_type = this.cache.type1;
            }, 0);
          } else {
            // 当只有转课类型时，
            if (this.searchInfo.order_type.includes(3)) {
              // order_type 长度为 1 或包含 2、5时不做处理
              if (
                this.searchInfo.order_type.length === 1 ||
                this.searchInfo.order_type.includes(2) ||
                this.searchInfo.order_type.includes(5)
              ) {
                console.log();
              } else {
                // 其他情况重置
                this.searchInfo.order_type = [];
                setTimeout(() => {
                  this.searchInfo.order_type = this.cache.type2;
                }, 0);
              }
            } else {
              if (
                this.searchInfo.order_type.includes(2) ||
                this.searchInfo.order_type.includes(5)
              ) {
                console.log();
              } else {
                // 其他情况重置
                this.searchInfo.order_type = [];
                setTimeout(() => {
                  this.searchInfo.order_type = this.cache.type2;
                }, 0);
              }
            }
          }
        } else {
          this.searchInfo.handle_time = null; // 清空支付时间
          this.searchInfo.refund_time = null; // 清空退款时间
          this.searchInfo.order_type = [];
          this.searchInfo.payment_type = -1;
        }
      }
      // 废除状态
      if (v === "repealStatus") {
        if (this.searchInfo.repeal_status > 0) {
          this.searchInfo.order_type =
            this.searchInfo.payment_type > -1
              ? [this.searchInfo.payment_type]
              : [];
          this.searchInfo.order_status = -1;
          this.searchInfo.refund_status = -1;
          this.searchInfo.handle_time = null;
          this.searchInfo.refund_time = null;
        } else {
          this.searchInfo.payment_type = -1;
          this.searchInfo.order_type = [];
        }
      }
      setTimeout(() => {
        _t.page = 1;
        _t.getorderlist({
          page: _t.page,
          page_size: _t.pageSize,
        });
      }, 0);
    },
    //我的订单
    getorderlist(params) {
      const _t = this;
      params.student_id = _t.id;
      if (_t.searchInfo.order_type && _t.searchInfo.order_type.length > 0) {
        params.order_type_arr = _t.searchInfo.order_type;
      }
      if (_t.searchInfo.course_id != "") {
        params.course_id = Number(_t.searchInfo.course_id);
      }

      if (_t.searchInfo.approval_status >= 0) {
        let arr = [];
        arr.push(Number(_t.searchInfo.approval_status));
        params.approval_status_arr = arr;
      }
      // 购课订单状态
      if (_t.searchInfo.order_status > 0) {
        params.payment_status = Number(_t.searchInfo.order_status);
      }
      // 退款订单状态
      if (_t.searchInfo.refund_status > 0) {
        params.payment_status = Number(_t.searchInfo.refund_status);
      }
      // 废除状态
      if (_t.searchInfo.repeal_status > 0) {
        params.status = Number(_t.searchInfo.repeal_status);
      }
      // 收支类型
      if (_t.searchInfo.payment_type > 0) {
        params.payment_type = Number(_t.searchInfo.payment_type);
      }
      if (_t.searchInfo.item_type > 0) {
        params.item_type = _t.searchInfo.item_type;
      }
      _t.getOrderTatistics(params);

      orderitemListApi(params).then((res) => {
        if (res.error_code == 0) {
          res.data.list.map((item) => {
            item.create_time = item.create_time
              ? dateFormat("YYYY-mm-dd HH:MM", item.create_time * 1000)
              : "-";
            item.handle_time = item.handle_time
              ? dateFormat("YYYY-mm-dd HH:MM", item.handle_time * 1000)
              : "-";
          });
          _t.tableData = res.data.list;
          _t.total = res.data.total;
          _t.page = res.data.page;
        }
      });
    },
    getOrderTatistics(params) {
      let option = {};
      option = params;
      orderTatisticsApi(option).then((res) => {
        if (res.error_code === 0) {
          this.tatistics = res.data;
        }
      });
    },
    // 已购课程和我的订单去到订单详情
    toDetail(id) {
      sessionStorage.setItem(
        "student_order_refund_route_history",
        JSON.stringify({
          student_id: this.$route.query.id,
        })
      );
      this.$router.push({
        name: "orderManageDetail",
        query: {
          id: String(id),
        },
      });
    },
    handlePagerChange(e) {
      this.page = e;
      this.getorderlist({
        page: this.page,
        page_size: this.pageSize,
        student_id: this.id,
      });
    },
    handlePagerSizeChange(e) {
      this.pageSize = e;
      this.getorderlist({
        page: this.page,
        page_size: this.pageSize,
        student_id: this.id,
      });
    },
    // 审批状态
    handleApprovalStatus(evt) {
      if (evt.order_type === 1) {
        switch (evt.approval_status) {
          case 0:
            return "无审批";
          case 1:
            return "审批中";
          case 2:
            return "已同意";
          case 3:
            return "已拒绝";
          case 4:
            return "已取消";
        }
        // if (evt.status === 2 || evt.status === 3) {
        //   switch (evt.approval_status) {
        //     case 0:
        //       return "无审批";
        //     case 1:
        //       return "审批中";
        //     case 2:
        //       return "已同意";
        //     case 3:
        //       return "已拒绝";
        //     case 4:
        //       return "已取消";
        //   }
        // }
      }
      if (evt.order_type === 2 || evt.order_type === 5) {
        if (evt.status === 4) {
          return "已取消";
        } else {
          switch (evt.approval_status) {
            case 0:
              return "无审批";
            case 1:
              return "审批中";
            case 2:
              return "已同意";
            case 3:
              return "已拒绝";
            case 4:
              return "已取消";
          }
        }
      }
      if (evt.order_type === 3 || evt.order_type === 4) {
        switch (evt.approval_status) {
          case 0:
            return "无审批";
          case 1:
            return "审批中";
          case 2:
            return "已同意";
          case 3:
            return "已拒绝";
          case 4:
            return "已取消";
        }
      }
      return "-";
    },
    // 订单状态
    handleOrderStatus(evt) {
      let type = evt.payment_type;
      if (evt.order_type === 3) {
        // 转课处理，根据原订单支付类型判断
        type = evt.order_payment_type;
      }
      if (type === 1) {
        switch (evt.status) {
          case 1:
            return "待付款";
          case 2:
            return "已付款";
          case 4:
            return "已取消";
          case 5:
            return "部分付款";
        }
      }
      if (type === 2) {
        if (evt.refund_failed) {
          return "退款失败";
        }
        switch (evt.status) {
          case 1:
            return "退款中";
          case 2:
            return "退款成功";
          case 3:
            return "已废除";
          case 4:
            return "已取消";
        }
      }
      return "-";
    },
  },
};
</script>
<style scoped lang="scss">
.container {
  .orderAmountBox {
    display: flex;
    .orderAmount {
      display: flex;
      align-items: center;
      background: #fff7e9;
      padding: 10px 10px;
      margin-bottom: 10px;
      border-radius: 4px;
      .question {
        width: 15px;
        height: 15px;
        opacity: 1;
        background: #bebfc0;
        border-radius: 50%;
        color: #fff;
        text-align: center;
        line-height: 16px;
        font-size: 10px;
        margin-left: 5px;
      }
    }
  }
  .ordernum {
    cursor: pointer;
  }
  .editBtn {
    color: #07d1aa;
  }
  .moneyType {
    padding: 4px;
    font-size: 12px;
    color: #fff;
    background: #07d1aa;
    border-radius: 4px;
  }
  .retreat {
    background: #f56c6c;
  }
}

/deep/.form {
  .el-form-item {
    display: flex;
    .el-form-item__label {
      min-width: 70px;
      text-align: left;
      padding: 0;
    }
    .el-form-item__content {
      width: 100%;
      .el-select {
        width: 90%;
      }
    }
  }
}
</style>
